export const IS_PRODUCTION = process.env.NODE_ENV === 'production'
export const AUTH_URL = process.env.VUE_APP_AUTH_URL
export const ASSETS_BASE_URL = process.env.VUE_APP_ASSETS_BASE_URL
export const GIT_COMMIT_ID = process.env.VUE_APP_GIT_COMMIT_ID
export const COUCHDB_URL = process.env.VUE_APP_COUCHDB_URL
export const COUCHDB_USERNAME = process.env.VUE_APP_COUCHDB_USERNAME
export const COUCHDB_PASSWORD = process.env.VUE_APP_COUCHDB_PASSWORD
